import { Material, MaterialNamesById, MaterialsById } from 'types';
import { transformObjectId } from './apiPlatformTransformer';

export const getMaterialsNamesById = (materials?: Material[] | null): MaterialNamesById => {
  if (!materials) return {};

  return materials.reduce<MaterialNamesById>((materialsNamesById, currentValue) => {
    materialsNamesById[parseInt(transformObjectId(currentValue))] = currentValue.shortName;
    return materialsNamesById;
  }, {});
};

export const getMaterialsById = (materials?: Material[] | null): MaterialsById | null => {
  if (!materials) return null;

  return materials.reduce<MaterialsById>((materialsById, currentValue) => {
    materialsById[parseInt(transformObjectId(currentValue))] = currentValue;
    return materialsById;
  }, {});
};
